import React, { useEffect, useRef, useState } from 'react';
import { Container, Form, Row, Button, Image, Col } from 'react-bootstrap';

import api from '../services/apiClient';
import { formatLocalDateTime } from '../utils/dateTime';

import { useMessage } from '../hooks/message';
import { useToast } from '../hooks/toast';
import { useUserStatus } from '../hooks/userStatus';

import DataClientService from '../interfaces/IDataClientService';

import MessagemOffIcon from '../assets/icon/mensagemOff.svg';
import AnaliseBIcon from '../assets/icon/analiseB.svg';
import AnalisePIcon from '../assets/icon/analiseP.svg';
import Users from '../interfaces/IUsers';

interface DataClient extends Omit<DataClientService, 'dtAtendimentoCriado'> {
  dtAtendimentoCriado: string | null;
}

const Message: React.FC<any> = () => {
  const {
    loadDataClienteRequestService,
    clientMessageService,
    SetClientMessageService,
  } = useMessage();
  const { addToast } = useToast();
  const { userStatus } = useUserStatus();
  const [rowSelected, setRowSelected] = useState(0);
  const [dadosMensagem, setDadosMensagem] = React.useState<DataClient>(
    {} as DataClient
  );
  const bntRefFinalizaAtendimento = useRef<HTMLButtonElement>(null);
  const [userResp, setUserResp] = useState(0);
  const [statusAtend, setStatusAtend] = useState(0);
  const [users, setUsers] = useState<Users[]>([]);

  const emptyData: DataClient = {
    seqAtendimento: 0,
    nomeCliente: '',
    emailCliente: '',
    nomeClinica: '',
    duvida: '',
    nomeProduto: '',
    seqStatusAtendimento: 0,
    nomeDepartamento: '',
    dtAtendimentoCriado: null,
    toggleSelected: false,
    idConexaoCliente: '',
    atendimentoMsgFinalizado: '',
    userAtendimento: null,
    seqDepartamento: 0,
    corDepartamento: '',
    corFundoLinha: '',
    nomeUsuario: '',
  };

  const loadUsers = (): void => {
    const token = localStorage.getItem('@LiveChat:token');

    api
      .get('/api/user/allUsers', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data;
        if (result) {
          setUsers(result.data);
        }
      });
  };

  const handleRowClicked = (idMensagem: number): void => {
    const row = clientMessageService.find(
      (msg) => msg.seqAtendimento === idMensagem
    );

    if (row) {
      setDadosMensagem(row);
      setUserResp(Number(row.userAtendimento));
    }
  };

  const handleGravaUser = (): void => {
    try {
      if (userResp === 0) {
        addToast({
          type: 'warning',
          title: 'Atenção',
          description: 'Selecione um usuário para gravar!',
        });
        return;
      }

      const token = localStorage.getItem('@LiveChat:token');

      api
        .patch(
          `MensagemCliente/${dadosMensagem.seqAtendimento}/User/${userResp}`,
          null,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((response) => {
          const { success } = response.data;
          if (success) {
            loadDataClienteRequestService();

            addToast({
              type: 'success',
              title: 'Sucesso',
              description: 'Usuário gravado com sucesso!',
            });
            return;
          }

          addToast({
            type: 'error',
            title: 'Erro',
            description: 'Não foi possível gravar o usuário!',
          });
        });
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro',
        description: 'Erro ao gravar o usuário!',
      });
    }
  };

  const handleFinalizarAtendimento = (): void => {
    try {
      if (userResp === 0) {
        addToast({
          type: 'warning',
          title: 'Atenção',
          description: 'Selecione um usuário para gravar!',
        });
        return;
      }

      const token = localStorage.getItem('@LiveChat:token');
      const usuario = localStorage.getItem('@LiveChat:seqUsuario');

      if (userResp !== Number(usuario)) {
        addToast({
          type: 'warning',
          title: 'Atenção',
          description:
            'A mensagem só pode ser finalizada pelo usuário responsável!',
        });
        return;
      }

      api
        .patch(
          `MensagemCliente/Finalizar/${dadosMensagem.seqAtendimento}/User/${userResp}`,
          null,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((response) => {
          const { success } = response.data;
          if (success) {
            setDadosMensagem(emptyData);
            setUserResp(0);
            loadDataClienteRequestService();

            addToast({
              type: 'success',
              title: 'Sucesso',
              description: 'Dados gravados com sucesso!',
            });
            return;
          }

          addToast({
            type: 'error',
            title: 'Erro',
            description: 'Não foi possível gravar os dados!',
          });
        });
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro',
        description: String(error),
      });
    }
  };

  const statusMensagem = (): number => {
    if (userResp === 0) return 0;

    if (userResp > 0 && dadosMensagem.atendimentoMsgFinalizado === 'N')
      return 1;

    return 2;
  };

  useEffect(() => {
    loadDataClienteRequestService();
    loadUsers();
    setDadosMensagem(emptyData);
  }, []);

  return (
    <div className="d-flex flex-column h-100 pb-2">
      <h1 className="fw-bold ms-2">Mensagens</h1>

      <div className="d-flex" style={{ flex: 1 }}>
        <section
          className="d-flex flex-column card position-static ms-2 w-50 overflow-hidden"
          style={{
            borderRadius: '0.68rem',
            boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
            flex: 1,
          }}
        >
          <table className="table table-nowrap table-hover mb-0">
            <thead
              className="small fw-light text-dark"
              style={{
                backgroundColor: '#D9D9D9',
                borderRadius: '0.68rem!important',
                fontSize: '1.25rem',
              }}
            >
              <tr style={{ fontSize: '1.125rem', fontWeight: '600' }}>
                <th className="col"> </th>
                <th className="col">Data</th>
                <th className="col">Nome</th>
                <th className="col">Departamento</th>
                <th className="col">Empresa</th>
              </tr>
            </thead>
            <tbody
              className="text-dark"
              style={{ borderColor: 'transparent', fontSize: '1.25rem' }}
            >
              {clientMessageService.map((msg) => (
                <tr
                  key={msg.seqAtendimento}
                  onClick={() => {
                    setRowSelected(msg.seqAtendimento);
                    handleRowClicked(msg.seqAtendimento);
                  }}
                  style={{
                    fontSize: '1.125rem',
                    fontWeight: '500',
                    backgroundColor:
                      rowSelected === msg.seqAtendimento ? '#0075FF' : '#FFF',
                    color: rowSelected === msg.seqAtendimento ? '#FFF' : '#000',
                  }}
                >
                  <td>
                    <Image
                      src={
                        rowSelected === msg.seqAtendimento
                          ? AnaliseBIcon
                          : AnalisePIcon
                      }
                      style={{
                        fill: '#000',
                        maxHeight: '1.37rem',
                        maxWidth: '1.37rem',
                      }}
                    />
                  </td>
                  <td>
                    {formatLocalDateTime(msg.dtAtendimentoCriado, 'dd/MM/yyyy')}
                  </td>
                  <td>{msg.nomeCliente}</td>
                  <td>{msg.nomeDepartamento}</td>
                  <td>{msg.nomeClinica}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <section
          className="d-flex flex-column w-50 ms-3 me-2"
          style={{
            borderRadius: '0.68rem',
            backgroundColor: '#FFF',
            fontSize: '1.25rem',
            boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
            flex: 1,
          }}
        >
          <div
            className="d-flex align-items-center ps-3"
            style={{
              borderTopLeftRadius: '0.68rem',
              borderTopRightRadius: '0.68rem',
              borderColor: 'transparent',
              backgroundColor: '#1A1A1A',
              fontSize: '1.25rem',
            }}
          >
            <Image
              style={{ height: '1.4rem', width: '1.5rem' }}
              src={MessagemOffIcon}
              alt="Mensagens"
            />
            <span
              style={{
                color: '#fff',
                fontSize: '1.58rem',
                marginLeft: '0.6rem',
              }}
            >
              Dados da mensagem
            </span>
          </div>
          <div>
            <Container className="mt-1 mb-3">
              <Row className="h-100">
                <Form.Group controlId="name">
                  <Form.Label className="mb-0">Nome</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={dadosMensagem.nomeCliente}
                    readOnly
                    className="mb-2 inputBox"
                    style={{ backgroundColor: '#E1E1E1' }}
                  />
                </Form.Group>

                <Form.Group controlId="inputEmail">
                  <Form.Label className="mb-0">E-mail</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={dadosMensagem.emailCliente}
                    readOnly
                    className="mb-2 inputBox"
                    style={{ backgroundColor: '#E1E1E1' }}
                  />
                </Form.Group>

                <Row style={{ paddingRight: '0' }}>
                  <Col style={{ paddingRight: '0' }}>
                    <Form.Group controlId="inputEmail">
                      <Form.Label className="mb-0">
                        Empresa / Cidade / Estado
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="clinicName"
                        value={dadosMensagem.nomeClinica}
                        readOnly
                        className="mb-2 inputBox"
                        style={{ backgroundColor: '#E1E1E1' }}
                      />
                    </Form.Group>
                  </Col>
                  <Col style={{ paddingRight: '0' }}>
                    <Form.Group controlId="inputEmail">
                      <Form.Label className="mb-0">
                        Produto / No. Contrato
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="product"
                        value={dadosMensagem.nomeProduto}
                        readOnly
                        className="mb-2 inputBox"
                        style={{ backgroundColor: '#E1E1E1' }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group controlId="inputEmail">
                  <Form.Label className="mb-0">Dúvida</Form.Label>
                  <Form.Control
                    type="text"
                    as="textarea"
                    rows={3}
                    name="question"
                    value={dadosMensagem.duvida}
                    readOnly
                    className="mb-2 "
                    style={{ backgroundColor: '#E1E1E1' }}
                  />
                </Form.Group>

                <Form.Group controlId="inputEmail">
                  <Form.Label className="mb-0">Departamento</Form.Label>
                  <Form.Control
                    type="text"
                    name="department"
                    value={dadosMensagem.nomeDepartamento}
                    readOnly
                    className="mb-2 inputBox"
                    style={{ backgroundColor: '#E1E1E1' }}
                  />
                </Form.Group>
              </Row>
              <Row>
                <Form.Group controlId="inputEmail">
                  <Row>
                    <Col>
                      <Form.Label className="mb-0">Responsável</Form.Label>
                      <Form.Select
                        name="responsavel"
                        disabled={rowSelected === 0}
                        value={userResp}
                        onChange={(e) => setUserResp(Number(e.target.value))}
                        className="mb-2 inputBox"
                      >
                        <option value={0}>Selecione</option>
                        {users.map((usr) => (
                          <option value={usr.seqUsuario}>
                            {usr.nomeUsuario}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Label className="mb-0">Status</Form.Label>
                      <Form.Select
                        name="responsavel"
                        value={statusMensagem()}
                        disabled
                        className="mb-2 inputBox"
                      >
                        <option value={0}>Em aberto</option>
                        <option value={1}>Em progresso</option>
                        <option value={2}>Finalizado</option>
                      </Form.Select>
                    </Col>
                  </Row>
                </Form.Group>
              </Row>
              <Row className="mt-5">
                <Col className="d-flex justify-content-center">
                  <Button
                    variant="danger"
                    type="button"
                    className="me-2"
                    disabled={
                      !dadosMensagem.seqAtendimento ||
                      dadosMensagem.atendimentoMsgFinalizado === 'S'
                    }
                    ref={bntRefFinalizaAtendimento}
                    onClick={() => {
                      handleFinalizarAtendimento();
                    }}
                  >
                    finalizar
                  </Button>

                  <Button
                    variant="primary"
                    type="button"
                    className="ms-2"
                    disabled={
                      !dadosMensagem.seqAtendimento ||
                      dadosMensagem.atendimentoMsgFinalizado === 'S'
                    }
                    onClick={() => {
                      handleGravaUser();
                    }}
                  >
                    salvar
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Message;
